module.exports = __webpack_public_path__ + "static/media/Taggis_portfolio_image.6be0b4c3.jpg";